import React from "react";
import styles from "./styles.module.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import cx from "classnames";

const CopyRight = () => {
  const history = useHistory();
  return (
    <div
      className={cx(
        styles.footerCopyRight,
        history?.location?.pathname !== "/" && styles.noPadding
      )}
    >
      <div>
        <p className={styles.footerItem}>
          <span>© 2020 - Bản quyền thuộc Công Ty Cổ Phần Ứng Dụng PKH</span>
          <span>
            <a
              title="DMCA.com Protection Status"
              href="https://www.dmca.com/Protection/Status.aspx?ID=c40b02e0-e3fb-4099-8bfa-16900ae9bd87&cdnrdr=1&refurl=https://medpro.vn/"
              rel="noreferrer"
              // rel="nofollow noopener"
              target="_blank"
              className="dmca-badge"
            >
              <img
                src="https://images.dmca.com/Badges/dmca-badge-w150-5x1-06.png?ID=c40b02e0-e3fb-4099-8bfa-16900ae9bd87"
                alt="DMCA.com Protection Status"
              />
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};

export default CopyRight;
